import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../../components/general/page";
import FulfilmentActivitiesPage from "../../../components/fulfilments/activities";
import { getFulfilmentCustomersActivities } from "../../../store/actions/fulfilments/activities";
import { useIntl } from "react-intl";

const FulfilmentActivitiesView = props => {
  const { pageRef } = props;

  const dispatch = useDispatch();

  const auth = useSelector(state => state.auth);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);

  const [title, setTitle] = useState("ADEMPIMENTI");
  const [response, setResponse] = useState({});

  const intl = useIntl();

  const fulfilmentId = window.location.href
    .split("activities/")[1]
    .split("?customer=")[0];
  const customerId = window.location.href
    .split("activities/")[1]
    .split("?customer=")[1];

  useEffect(() => {
    reloadData();
  }, []);

  const reloadData = () => {
    dispatch(getFulfilmentCustomersActivities(
      auth,
      fulfilmentId,
      main.accountantUuidSelected,
      customerId
    )).then(res => {
      setResponse(res);
    });
  };

  useEffect(() => {
    setTitle("ADEMPIMENTI" +
      (response && response.fulfilment
        ? ` - ${response.fulfilment.description}`
        : ""));
  }, [response]);

  let subtitle = "";
  let companySel;

  if (main.companyUuidSelected) {
    if (company.companies) {
      companySel = company.companies.find(x => x.uuid === main.companyUuidSelected);
      if (companySel) {
        subtitle = `${companySel.ragioneSociale} / ${intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" })} ${companySel.codiceFiscale}`;
      }
    }
  }

  return (
    <Page
      pageRef={pageRef}
      title={title}
      subtitle={subtitle}
      backUrl="/fulfilments"
      backText="Torna a tutti gli adempimenti"      
    >
      <FulfilmentActivitiesPage
        fulfilmentId={fulfilmentId}
        customerId={customerId}
        companySel={companySel}        
        response={response}
        reloadData={reloadData}
      />
    </Page>
  );
};

export default FulfilmentActivitiesView;
